<div class="container-fluid ptCustom">

    <div class="row">
        <div class="col-12 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="row align-items-end">
                        <div class="input-group mb-3 mb-xl-0">
                            <input (keyup)="enterSearchTerm($event)" [(ngModel)]='searchText' type="text"
                                class="form-control form-control-lg" placeholder="search invoices...">
                            <button class="btn btn-lg btn-db border-lb dropdown-toggle" type="button" id="searchFilter"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Status: {{statusSearch.display}}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="searchFilter">
                                <li><a *ngIf="statusSearch.value != -1" (click)="changeStatusSearch(-1)"
                                        class="dropdown-item" href="javascript:void(0)">Status: All</a></li>
                                <li><a *ngIf="statusSearch.value != 0" (click)="changeStatusSearch(0)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Invoiced</a></li>
                                <li><a *ngIf="statusSearch.value != 1" (click)="changeStatusSearch(1)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Partially Paid</a></li>
                                <li><a *ngIf="statusSearch.value != 2" (click)="changeStatusSearch(2)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Paid In Full</a></li>
                                <li><a *ngIf="statusSearch.value != 3" (click)="changeStatusSearch(3)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Past Due</a></li>
                                <li><a *ngIf="statusSearch.value != -9999" (click)="changeStatusSearch(-9999)"
                                        class="dropdown-item" href="javascript:void(0)">Status: Cancelled</a></li>
                            </ul>
                            <button (click)="hitSearchBtn()" type="button" class="btn btn-lg btn-sb border-lb"><i
                                    class="fas fa-search"></i></button>
                            <button (click)="clearSearch()" type="button" class="btn btn-lg btn-primary border-lb"><i
                                    class="fas fa-times"></i></button>
                        </div>
                        <div class="search-filters py-2">
                            <!-- hide if none -->
                            <ul class="filter-tags" *ngIf="keywordSearches.length > 0">
                                <li (click)="removeSearchTerm(search)" *ngFor="let search of keywordSearches"
                                    class="tag">
                                    <span>{{search}}</span><span class="remove-tag"><i
                                            class="fa fa-times-circle"></i></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-lg-3">
                            <label for="invoiceFilter1" class="form-label">Filter</label>
                            <select class="form-select" aria-label="invoiceFilter1" id="invoiceFilter1">
                                <option selected>All</option>
                                <option value="1">filter</option>
                            </select>
                        </div>
                        <div class="col-lg-3">
                            <label for="invoiceFilter2" class="form-label">Filter</label>
                            <select class="form-select" aria-label="invoiceFilter2" id="invoiceFilter2">
                                <option selected>All</option>
                                <option value="1">filter</option>
                            </select>
                        </div>
                        <div class="col-lg-3">
                            <label for="invoiceFilter2" class="form-label">Filter</label>
                            <select class="form-select" aria-label="invoiceFilter2" id="invoiceFilter2">
                                <option selected>All</option>
                                <option value="1">filter</option>
                            </select>
                        </div>
                        <div class="col-lg-3">
                            <label for="invoiceFilter2" class="form-label">Filter</label>
                            <select class="form-select" aria-label="invoiceFilter2" id="invoiceFilter2">
                                <option selected>All</option>
                                <option value="1">filter</option>
                            </select>
                        </div>
                    </div> -->

                    <div class="d-flex align-items-center justify-content-between mt-4 pt-4 border-top border-50 mb-4 ">
                        <div>
                            <div class="fs-5 fst-italic">viewing {{itemStart}}-{{itemEnd}} of {{filteredAdmin}} invoices
                            </div>
                        </div>
                        <div>
                            <a type="button" class="btn btn-outline-light text-strong px-4 me-2 shadow-sm"
                            [routerLink]="['/admin-portal/member/non-invoice-payment']">non-invoice payments</a>
                            <a *ngIf="selectedInvoicesCount > 0" type="button" class="btn btn-add text-strong px-4 shadow-sm" [routerLink]="['/admin-portal/member/invoice-payment/', invoiceIdsString]">
                                pay ({{selectedInvoicesCount}}) invoices: <span
                                    class="fw-bold">{{runningTotal| currency:'USD':'symbol' }}</span> <i class="fa-solid fa-arrow-right"></i></a>
                        </div>
                    </div>
                    <div class="card no-shadow border border-db bg-db p-2">
                        <div class="invoiceTable">
                            <table class="table table-hover align-middle m-0">
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="form-check">
                                                <label class="form-check-label fw-light d-none" for="selectAllCheck">
                                                    <small>Select</small>
                                                </label>
                                                <input [(ngModel)]="allSelected" (change)="selectAllInvoices()" class="form-check-input" type="checkbox" value="selectAllCheck"
                                                       id="selectAllCheck" aria-label="select all">
                                            </div>
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(1)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 1}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 2}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Invoice Date
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(2)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 3}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 4}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Due Date
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(3)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 5}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 6}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Invoice #/Memo
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(4)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 7}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 8}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Status
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(5)" href="javascript:void(0)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 9}" class="icon">
                                                    <i class="far fa-long-arrow-alt-up"></i>
                                                </span>
                                                <span [ngClass]="{'active': sortType == 10}" class="icon">
                                                    <i class="far fa-long-arrow-alt-down"></i>
                                                </span>
                                            </a>Amount
                                        </th>
                                        <!-- <th>Actions</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let invoice of memberInvoices"
                                        [ngClass]="{'rowWarning': invoice.status == 3, 'invoiceSelected': invoice.isSelected}">
                                        <td>
                                            <input  *ngIf="invoice.status == 0 || invoice.status == 1 || invoice.status == 3" class="form-check-input" [(ngModel)]="invoice.isSelected"
                                            (change)="selectInvoice(invoice)"
                                                type="checkbox" value="selectInvoice1" id="selectInvoice1"
                                                aria-label="select invoice 1">
                                        </td>
                                        <td>
                                            {{invoice.invoiceDateString}}
                                        </td>
                                        <td>
                                            <span *ngIf="invoice.status == 3" class="overdueIcon">
                                                <i class="fa-solid fa-triangle-exclamation"></i>
                                            </span>{{invoice.dueDateString}}
                                        </td>
                                        <td>
                                            <div>
                                                <p class="m-0">{{invoice.name}}</p>
                                                <!-- <small class="text-muted">
                                                    {{invoice.memo}}
                                                </small> -->
                                            </div>
                                        </td>
                                        <td>
                                            <span *ngIf="invoice.status == 0" class="fw-bold">Invoiced</span>
                                            <span *ngIf="invoice.status == 1" class="fw-bold">Partially Paid</span>
                                            <span *ngIf="invoice.status == 2" class="fw-bold">Paid In Full</span>
                                            <span *ngIf="invoice.status == 3" class="fw-bold">Overdue</span>
                                            <span *ngIf="invoice.status == -9999" class="fw-bold">Canceled</span>
                                        </td>
                                        <td class="text-end">
                                            {{invoice.amountString}}
                                        </td>
                                        <!-- <td class="text-end">
                                            <div class="dropdown">
                                                <button class="btn btn-lg btn-outline-dark action-btn" type="button"
                                                    id="dropdownMenuButton1" data-bs-toggle="dropdown"
                                                    aria-expanded="false">
                                                    <i class="far fa-ellipsis-v"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end"
                                                    aria-labelledby="dropdownMenuButton1">
                                                    <li><a class="dropdown-item" href="javascript:void(0)"
                                                            (click)="openViewInvoiceModal()" data-bs-target="#"><i
                                                                class="fa-light fa-eye fa-fw"></i> View Invoice?</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td> -->
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <nav aria-label="table navigation" class="d-flex align-items-center justify-content-center">
                            <ngb-pagination class="pagination mb-0" [maxSize]="5" [ellipses]="true"
                                [collectionSize]="filteredAdmin" [(page)]="currentPageNum" [pageSize]="itemsPerPage">
                            </ngb-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>